import React from 'react';
import { Link } from 'react-router-dom';
import { Package, Headphones } from 'lucide-react';
import './TopBar.css';

// Custom inline SVG icons for brands
const InstagramIcon = ({ size = 14 }) => (
  <svg 
    viewBox="0 0 24 24" 
    width={size} 
    height={size} 
    stroke="currentColor" 
    strokeWidth="2" 
    fill="none" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
  </svg>
);

const FacebookIcon = ({ size = 14 }) => (
  <svg 
    viewBox="0 0 24 24" 
    width={size} 
    height={size} 
    stroke="currentColor" 
    strokeWidth="2" 
    fill="none" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M18 2h-3a5 5 0 0 0 -5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
  </svg>
);

const YoutubeIcon = ({ size = 14 }) => (
  <svg 
    viewBox="0 0 24 24" 
    width={size} 
    height={size} 
    stroke="currentColor" 
    strokeWidth="2" 
    fill="none" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path>
    <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>
  </svg>
);

const TopBar = () => {
  return (
    <div className="top-bar-bg">
      <div className="container top-bar-container">
        {/* Left: Social Media Icons */}
        <div className="top-bar-socials">
          <a href="#instagram" className="top-bar-social-link" aria-label="Instagram">
            <InstagramIcon size={14} />
          </a>
          <a href="#facebook" className="top-bar-social-link" aria-label="Facebook">
            <FacebookIcon size={14} />
          </a>
          <a href="#youtube" className="top-bar-social-link" aria-label="YouTube">
            <YoutubeIcon size={14} />
          </a>
        </div>

        {/* Right: Track Order & Support */}
        <div className="top-bar-right">
          <Link to="/track">
            <Package size={14} />
            <span>Track Order</span>
          </Link>
          <a href="#support">
            <Headphones size={14} />
            <span>Help & Support</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
